import { render } from "./PageHeader.vue?vue&type=template&id=5947c6b4"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__